export type ManagedPageKey = "news" | "openday" | "circolari";

export type PagesVisibility = Record<ManagedPageKey, boolean>;

export const DEFAULT_PAGES_VISIBILITY: PagesVisibility = {
	news: true,
	openday: true,
	circolari: true,
};

export const MANAGED_PAGE_ROUTES: Record<ManagedPageKey, string> = {
	news: "/news",
	openday: "/openday",
	circolari: "/documentazione/circolari",
};

export const MANAGED_PAGE_LABELS: Record<ManagedPageKey, string> = {
	news: "News",
	openday: "Open Day",
	circolari: "Circolari",
};

const ROUTE_TO_KEY = Object.fromEntries(
	Object.entries(MANAGED_PAGE_ROUTES).map(([key, href]) => [href, key]),
) as Record<string, ManagedPageKey>;

export function pageKeyFromHref(href: string): ManagedPageKey | null {
	return ROUTE_TO_KEY[href] ?? null;
}

/** Visibilità nel menu: vale per tutti, admin inclusi (anteprima fedele al sito pubblico). */
export function isHrefVisibleForUser(
	href: string,
	pages: PagesVisibility,
): boolean {
	const key = pageKeyFromHref(href);
	if (!key) return true;
	return pages[key] !== false;
}

export function isPageVisibleForUser(
	key: ManagedPageKey,
	pages: PagesVisibility,
	isAdmin: boolean,
): boolean {
	if (isAdmin) return true;
	return pages[key] !== false;
}
